import { useEffect } from 'react'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import { prefetchPortfolio, usePortfolio } from 'querys/portfolio'
import InternalError from 'errors/internal-error'
import PortfolioHero from 'components/portfolio/portfolio-hero'
import PortfolioContact from 'components/portfolio/portfolio-contact'
import PortfolioProjects from 'components/portfolio/portfolio-projects'
import PortfolioNavigation from 'components/portfolio/portfolio-navigation'
import PortfolioTestimonies from 'components/portfolio/portfolio-testimonies'
import OpenGraph from 'common/open-graph'
import Error from 'components/errors/error'
import LoadingState from 'common/loading-state'
import { useRouter } from 'next/router'
import { createGlobalStyle } from 'styled-components'

const UserPortfolioStyled = createGlobalStyle`
  body {
    background: var(--neutral110);
    color: var(--white);
  }
`

function UserPortfolio({ username }) {
  const { isFallback } = useRouter()
  const {
    data, isError, error, isLoading,
  } = usePortfolio()

  useEffect(() => {
    if (data?.email) {
      const { hash } = window.location
      if (!hash) return
      const section = document.querySelector(hash)
      console.log(section, hash)
      if (section) {
        section.scrollIntoView()
      }
    }
  }, [data?.email])

  if (isFallback || (!data && isLoading)) {
    return (
      <>
        <LoadingState />
      </>
    )
  }

  if (error?.message === 'Not Found') {
    return (
      <Error status="404" description="Esta cuenta no existe, intenta con otro usuario" />
    )
  }

  if (error?.message === 'Internal Error') return <InternalError />

  if (isError) return <InternalError />

  return (
  <>
    <UserPortfolioStyled />
    <OpenGraph
      title="Bienvenido a mi portafolio"
      url={`https://leonidasesteban.com/estudiantes/${username}`}
      keyword="Desarrollo Web, Portafolio, Proyectos Frontend"
      description="Te presento mis mejores proyectos como desarrollador web junto a los testimonios de mis compañeros."
      image="/images/portfolio/work-together.jpg"
    />
    <PortfolioNavigation />
    <PortfolioHero />
    <PortfolioProjects />
    <PortfolioTestimonies />
    <PortfolioContact />
  </>
  )
}

export async function getStaticPaths() {
  return {
    paths: [
      { params: { username: 'not-found' } },
    ],
    fallback: true,
  }
}


export async function getStaticProps({ params: { username } }) {
  const queryClient = new QueryClient()
  await prefetchPortfolio({ queryClient, username })
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      username,
    },
  }
}

export default UserPortfolio
